// MEMS microphone frequency response correction table
// Measured sensitivity in dB relative to 1kHz
// Data extracted via WebPlotDigitizer from manufacturer datasheet
// For frequencies beyond 80kHz, linearly extrapolated from last two points

const micResponseTable = [
  [297.0, 0.026],
  [1287.1, 0.053],
  [3514.9, 0.158],
  [4925.7, 0.210],
  [6485.1, 0.368],
  [9009.9, 0.736],
  [11237.6, 1.103],
  [13762.4, 1.708],
  [16188.1, 2.391],
  [18267.3, 3.152],
  [20049.5, 3.993],
  [20742.6, 4.098],
  [21460.4, 4.046],
  [21831.7, 4.492],
  [22227.7, 4.807],
  [22722.8, 5.096],
  [23168.3, 5.359],
  [23539.6, 5.806],
  [24133.7, 6.988],
  [24678.2, 8.196],
  [25371.3, 9.562],
  [26287.1, 11.191],
  [27376.2, 12.557],
  [28217.8, 13.765],
  [29158.4, 15.289],
  [30173.3, 16.970],
  [30990.1, 18.809],
  [31707.9, 20.701],
  [32326.7, 21.856],
  [32698.0, 22.750],
  [32995.0, 24.063],
  [33168.3, 25.009],
  [33589.1, 26.112],
  [33985.1, 26.585],
  [34381.2, 26.112],
  [34653.5, 25.534],
  [35198.0, 24.378],
  [35668.3, 23.380],
  [36311.9, 22.434],
  [37351.5, 21.436],
  [38143.6, 20.648],
  [38910.9, 19.703],
  [39579.2, 18.809],
  [40445.5, 17.706],
  [41435.6, 16.340],
  [42376.2, 15.184],
  [43638.6, 14.291],
  [44678.2, 13.345],
  [45495.0, 12.793],
  [46039.6, 12.872],
  [46633.7, 13.319],
  [47227.7, 13.765],
  [47920.8, 14.107],
  [48762.4, 14.186],
  [49752.5, 14.081],
  [50693.1, 13.897],
  [51732.7, 13.634],
  [52821.8, 13.371],
  [53712.9, 13.319],
  [54851.5, 13.424],
  [55940.6, 13.240],
  [56782.2, 12.977],
  [57772.3, 12.688],
  [58762.4, 12.478],
  [59653.5, 12.426],
  [60841.6, 12.583],
  [61930.7, 13.004],
  [63316.8, 13.581],
  [64653.5, 14.133],
  [66089.1, 14.501],
  [67574.3, 15.053],
  [69158.4, 15.814],
  [70742.6, 16.734],
  [72227.7, 17.811],
  [73861.4, 18.835],
  [75099.0, 19.308],
  [75940.6, 19.256],
  [76683.2, 18.888],
  [77376.2, 18.494],
  [78069.3, 18.100],
  [78811.9, 17.627],
  [79505.0, 17.102],
  [80000.0, 16.629],
  // Extrapolated beyond 80kHz using slope from last two points
  [84000.0, 14.7],
  [88000.0, 12.8],
  [92000.0, 10.9],
  [96000.0, 9.0],
];

// Get the mic sensitivity in dB at a given frequency using linear interpolation
export function getMicSensitivityDb(freqHz) {
  if (freqHz <= micResponseTable[0][0]) return micResponseTable[0][1];
  const last = micResponseTable[micResponseTable.length - 1];
  if (freqHz >= last[0]) return last[1];

  for (let i = 1; i < micResponseTable.length; i++) {
    if (freqHz <= micResponseTable[i][0]) {
      const [f0, s0] = micResponseTable[i - 1];
      const [f1, s1] = micResponseTable[i];
      const t = (freqHz - f0) / (f1 - f0);
      return s0 + t * (s1 - s0);
    }
  }
  return last[1];
}

// Build a correction array for a given FFT setup
// Returns an array of linear gain divisors, one per frequency bin
export function buildMicCorrectionTable(numBins, binFrequency) {
  const correction = new Float32Array(numBins);
  for (let i = 0; i < numBins; i++) {
    const freq = i * binFrequency;
    const sensitivityDb = getMicSensitivityDb(freq);
    // Convert dB to linear gain: 10^(dB/20)
    correction[i] = Math.pow(10, sensitivityDb / 20);
  }
  return correction;
}

export default micResponseTable;
